<template>
  <div class="statPopoverGraph">
    <div class="tooltipPopover"
         :style="tooltipStyle"
         :id="guid">
      <div>{{ tooltipLabel }}:&nbsp;&nbsp;<span style="font-weight: bold;">{{ tooltipValue }}</span></div>
      <div class="tooltipPopoverArrow"></div>
    </div>
    <pie-chart
      :width="150"
      :height="150"
      :options="chartOptions"
      :chart-data="chartData">
    </pie-chart>
    <div class="statPopoverGraph-heroStat">
      <div class="statPopoverGraph-heroStat-data">
        {{ heroStat | nebFormat }}
      </div>
    </div>
  </div>
</template>

<script>
  import PieChart from '@/charts/PieChart'

  export default {
    components: {
      PieChart
    },
    name: 'stat-popover-graph',
    props: ['data', 'heroStat'],
    data () {
      const vm = this
      return {
        guid: Math.random() * 1000000000000000000,
        tooltipLabel: null,
        tooltipValue: null,
        showTooltip: false,
        tooltipTop: false,
        tooltipLeft: false,
        chartOptions: {
          cutoutPercentage: 53,
          responsive: false,
          legend: false,
          animation: false,
          scaleShowLabels: false,
          tooltips: {
            callbacks: {
              title: function (t) {
                const dataIndex = t[0].index
                const dataSet = vm.chartData.datasets[t[0].datasetIndex]
                const val = vm.$options.filters['nebFormat']({type: dataSet.types[dataIndex], value: dataSet.data[dataIndex]})
                const label = vm.chartData.labels[dataIndex]

                return [val, label]
              }
            },
            enabled: false,
            custom: function (tooltipModel) {
              // Hide if no tooltip
              if (tooltipModel.opacity === 0 || vm.data.length === 0) {
                vm.showTooltip = false
                return
              }

              vm.tooltipValue = tooltipModel.title[0]
              vm.tooltipLabel = tooltipModel.title[1]
              vm.showTooltip = true

              const element = document.getElementById(vm.guid)
              if (element) {
                vm.$nextTick(() => {
                  vm.tooltipLeft = tooltipModel.caretX - (element.offsetWidth / 2) + 'px'
                  vm.tooltipTop = tooltipModel.caretY - (element.offsetHeight / 2) - 20 + 'px'
                })
              }
            }

          }
        }
      }
    },
    computed: {
      tooltipStyle () {
        return {
          top: `${this.tooltipTop}`,
          left: `${this.tooltipLeft}`,
          opacity: this.showTooltip ? 1 : 0,
          'z-index': this.showTooltip ? 1000 : -1000
        }
      },
      chartData () {
        const chartData = {
          labels: [],
          datasets: [
            {
              backgroundColor: [],
              data: [],
              types: [],
              borderWidth: 0
            }
          ]
        }

        if (this.data.length === 0) {
          // Display a solid gray placeholder graph
          chartData.datasets[0].backgroundColor = ['#EFEFEF']
          chartData.datasets[0].hoverBackgroundColor = ['#EFEFEF']
          chartData.datasets[0].data.push(1)
        } else {
          for (const d of this.data) {
            chartData.datasets[0].data.push(d.value)
            chartData.datasets[0].types.push(d.type)
            chartData.datasets[0].backgroundColor.push(d.color)
            chartData.labels.push(d.label)
          }
        }

        return chartData
      }
    }
  }
</script>

<style lang="scss" scoped>
.statPopoverGraph {
  position: relative;

  $tooltip-popover-height: 28px;

  .tooltipPopover {
    pointer-events: none;
    white-space: nowrap;
    position: absolute;
    font-size: 12px;
    height: $tooltip-popover-height;
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px #b6b6b6;
    padding: 0 12px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.5));
  }

  .tooltipPopoverArrow {
    $triangle-size: 5px;
    position: absolute;
    top: $tooltip-popover-height;
    width: 0;
    height: 0;

    border-left: $triangle-size solid transparent;
    border-right: $triangle-size solid transparent;
    border-top: $triangle-size solid #000000;
    z-index: 1;

    &:after {
      position: absolute;
      top: -$triangle-size;
      left: -$triangle-size;
      content: "";
      width: 0;
      height: 0;
      border-left: $triangle-size solid transparent;
      border-right: $triangle-size solid transparent;
      border-top: $triangle-size solid #FFFFFF;
    }
  }

  &-heroStat {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
